import * as React from 'react'

function PhoneFilledSvg({
  fill = 'currentcolor',
  ...rest
}: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...rest}>
      <path
        d="M21.2036 16.7519L19.0251 15.2395C18.1872 14.7354 17.1817 14.9034 16.5114 15.5756L15.1708 17.2561H15.0032L14.6681 17.9282L15.0032 17.2561C14.8357 17.2561 14.8357 17.088 14.6681 17.088C14.3329 16.92 13.8302 16.5839 13.3275 16.2478C12.6572 15.7437 11.8193 15.0715 10.6463 13.8952C9.47323 12.7189 8.80291 11.8786 8.30018 11.2065C7.96503 10.7023 7.62987 10.3662 7.4623 9.86208C7.4623 9.69403 7.29474 9.69406 7.29474 9.52602V9.35796L8.9705 8.01363C9.6408 7.5095 9.80838 6.33319 9.30565 5.49296L7.96503 3.30836L6.28927 0.787694C5.78654 -0.0525279 4.61351 -0.220552 3.77562 0.283581L1.76471 1.45986C1.09441 1.96399 0.59169 2.63618 0.256538 3.30836C-0.413767 5.66098 -0.246201 10.1982 6.792 17.2561C13.8302 24.3139 18.3548 24.3139 20.7008 23.8098C21.5387 23.6417 22.209 23.1376 22.5442 22.2974L23.7172 20.2808C24.2199 19.4406 24.0524 18.4324 23.2145 17.7602L21.2036 16.7519Z"
        fill={fill}
      />
    </svg>
  )
}

export const PhoneFilled = React.memo(PhoneFilledSvg)
